/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmKombinacePostSluzeb extends GContentBase<SeznamAdmKombinacePostSluzebObj> {
        private seznamObj: SeznamAdmKombinacePostSluzebObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmKombinacePostSluzebObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmKombinacePostSluzeb",
                contentCaption: "jres:33000233", //RC 33000233 : Oblíbené poštovní služby
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{komb_sluzeb}"
                },
                gridSettings: {
                    columnOrder: "komb_sluzeb,komb_sluzeb_txt,nazev,zmenu_prov_txt,dat_zmena,filtr_format"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmKombinacePostSluzebObj extends GAdmSeznamBase {
        create() {

        }

        openDetail(data: any, isNew: boolean) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmKombinacePostSluzeb", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailAdmKombinacePostSluzeb",
                newRecord: isNew,
                komb_sluzeb: isNew == true ? null : data.komb_sluzeb
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison*"]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*"])
        }

        createFilterForm() {
            
        }

        userhardDefaultFilter(hardFilter: any): any {
            return hardFilter;
        }

        collectData(data: any) {

        }

        applydata(filterData: any) {
            this.cnt.isl.AdmKombinacePostSluzeb.list({ filters: filterData }).getView().done((data) => {
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {

        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "{0}".format(data.komb_sluzeb),
                nazev: ""
            }
        }
    }
}